module.exports = __webpack_public_path__ + "img/friends-blue.cdb6f09e.svg";